// @ts-nocheck

import { match as MatchStateUtils } from '..';
import { __ } from '../../i18n/l10n';
import type { ScoreboardProps, SecondariesScoreType } from '../../states/scoreboards';

export const computeSecondaryScores = (scores: Array<string>): SecondariesScoreType => {
  return [
    {
      label: __('Map %1$s', scores.length),
      score: [...scores].pop().split(':'),
    },
  ];
};

const esportCounterStrikeScoreBoard = ({
  sportId,
  matchId,
  period,
  periodName,
  setScores,
  competitor1Name,
  competitor2Name,
  competitor1Flag,
  competitor2Flag,
  score,
}: unknown): ScoreboardProps => {
  let scores = null;
  let gameScores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  if (score && score !== '') {
    gameScores = score.split(':');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
      },
    ],
    scores: {
      main: {
        label: __('Match'),
        score: gameScores ? gameScores : ['', ''],
      },
      secondaries: scores ? computeSecondaryScores(scores) : [],
    },
  };
};

export default esportCounterStrikeScoreBoard;
